module.exports = "/_next/static/images/CommitmentSafetyExcellence-4e47efec23feaebef721d5e203572bec.webp";